


export const products = [
    {
        id:1,
        img:"images/weatherApp.png",
        link:"https://github.com/coderhopeful/weatherForecastApp.git",
        name:"weatherApp"
    },

    {
        id:2,
        img:"images/bankApp.jpg",
        link:"https://github.com/coderhopeful/bankingWebApp.git",
        name:"bankApp"
    },

    {
        id:3,
        img:"images/vaccination.png",
        link:"https://github.com/coderhopeful/Vaccination.git",
        name:"vaccination"
    },

    {
        id:4,
        img:"images/restaurant.png",
        link:"https://github.com/coderhopeful/restaurant.git",
        name:"restaurant"
    }

];